import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    maxWidth: 400,
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    boxShadow: '0 0 40px 0 rgba(0, 0, 0, 0.2)',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '&:focus': {
      outline: 'none',
    },
    '@media screen and (max-width: 640px)': {
      width: '304px',
    },
  },
  iconCloseBtn: {
    margin: '5px 0 0 0',
  },
  closeIcon: {
    maxWidth: '16px',
  },
  newTitleModal: {
    '@media screen and (max-width: 1280px)': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'nowrap',
    },
  },
  widthNewTitle: {
    display: 'none',
    width: '100%',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    textAlign: 'center',
    color: '#000000',
    paddingLeft: '40px',
    '@media screen and (max-width: 1280px)': {
      display: 'block',
    },
  },
}))
